import React, {useState} from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ToPicking from "../../component/picking/ToPicking";
import Picked from "../../component/picking/Picked";
import {useGetPickingList} from "../../hooks/usePicking";
import {useNavigate} from "react-router-dom";
import Ebay from "../../component/screening/Ebay";

const Picking = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const navigate = useNavigate();
    const {data: allPickingList, isLoading: isPickingLoading} = useGetPickingList({limit: currentPage});
    return (
        <>
            <Container fluid>
                <i onClick={() => navigate(-1)} className="fa-solid fa-arrow-left"/>
                <Row lg={12}>
                    <Col lg={3}>
                        <Ebay
                            totalFreightCount={0}
                            totalGroundCount={0}
                            isScreeningLoading={isPickingLoading}
                            />
                    </Col>
                    <Col lg={6}>
                        <ToPicking
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                            allPickingList={allPickingList}
                            isPickingLoading={isPickingLoading}
                        />
                    </Col>
                    <Col lg={3}>
                        <Picked
                            dailyAverage={allPickingList?.dailyAverage || 0}
                            weeklyAverage={allPickingList?.weeklyAverage || 0}
                            monthlyAverage={allPickingList?.monthlyAverage || 0}
                            isPickLoading={isPickingLoading}
                        />
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default Picking;